export async function ptlReleaseOrdersUseCase(trace_id, shipmentRepository) {
    
    const result = await shipmentRepository.ptl_release_orders(trace_id);

    return result;
}